import React from 'react';
import { Link } from 'react-router-dom';
import { Car, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-charcoal border-t border-brand-gold/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          
          <div>
            <Link to="/" className="inline-flex items-center space-x-2 text-2xl font-serif font-bold text-brand-gold mb-4 justify-center md:justify-start">
              <Car size={32} />
              <span>Akiblackcar</span>
            </Link>
            <p className="text-gray-400">
              Your trusted partner for luxury transportation in the DMV area.
            </p>
          </div>

          <div>
            <p className="font-bold text-white text-lg mb-4 uppercase tracking-wider">Quick Links</p>
            <ul className="space-y-2">
              <li><Link to="/fleet" className="text-gray-400 hover:text-brand-gold transition-colors">Our Fleet</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-brand-gold transition-colors">Our Services</Link></li>
              <li><Link to="/booking" className="text-gray-400 hover:text-brand-gold transition-colors">Booking</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-brand-gold transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-bold text-white text-lg mb-4 uppercase tracking-wider">Contact Info</p>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center justify-center md:justify-start">
                <Phone className="w-5 h-5 mr-3 text-brand-gold" />
                <a href="tel:7038431837" className="hover:text-brand-gold transition-colors">(703) 843-1837</a>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <Mail className="w-5 h-5 mr-3 text-brand-gold" />
                <a href="mailto:Akiblackcar@gmail.com" className="hover:text-brand-gold transition-colors">Akiblackcar@gmail.com</a>
              </li>
            </ul>
          </div>

        </div>

        <div className="mt-8 pt-8 border-t border-brand-gold/10 text-center text-gray-500">
          <p>&copy; {currentYear} Akiblackcar. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;